import CardTagged from '../../../components/ui/CardTagged/CardTagged'
import { Box, HStack, Progress, Text } from '@chakra-ui/react'
import ReportStaffDetail from './ReportStaffDetail/ReportStaffDetail'
import React from 'react'
import MoreMenu from '../../../components/ui/MoreMenu'
import { useReportStaffActions } from './ReportListItem.utils'

export const ReportListItem = ({ report, onClick, isAdmin }) => {
  const { actions, deleteReport } = useReportStaffActions({
    reportTicket: report,
  })
  return (
    <CardTagged
      position="relative"
      cursor="pointer"
      key={report.id}
      borderLeftColor={report.color || 'brand.orange'}
      onClick={onClick}
      opacity={deleteReport.isLoading ? 0.5 : 1}
      pointerEvents={deleteReport.isLoading ? 'none' : 'auto'}>
      {deleteReport.isLoading && (
        <Progress
          position="absolute"
          top="0"
          left="0"
          w="100%"
          size="xs"
          colorScheme="blue"
          isIndeterminate
        />
      )}
      <HStack p="20px 36px 24px">
        <Box>
          <Text textStyle="h2">{report.name}</Text>
          {/* Only show description or ID if ID isn't "LiveReport" */}
          {report.description || (report.id !== 'LiveReport' && report.id) ? (
            <Text
              textStyle="p"
              mt="3px">
              {report.description ||
                (report.id !== 'LiveReport' ? report.id : '')}
            </Text>
          ) : null}
        </Box>
      </HStack>
      {isAdmin && (
        <>
          <Box
            position="absolute"
            right="16px"
            top="16px">
            <MoreMenu
              actions={actions}
              iconSize={24}
              onClick={e => e.stopPropagation()}
            />
          </Box>
          {/* Only render ReportStaffDetail if there's useful content to show */}
          {report.ticket && report.ticket.notes && (
            <ReportStaffDetail reportTicket={{ ...report.ticket }} />
          )}
        </>
      )}
    </CardTagged>
  )
}
